import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import { Button, ButtonContainer, H3 as _H3 } from "./typography";

const Wrapper = styled.div`
  background: white;
  border-radius: 8px;
  margin-top: 8px;
  margin-bottom: 8px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 650px) {
    width: 100%;
    flex-direction: column;
  }
`;

const Tags = styled.div`
  display: flex;
  margin-top: 16px;
`;

const Tag = styled.div`
  color: #be5b04;
  border: 1px solid #be5b04;
  border-radius: 4px;
  margin-right: 8px;
  padding: 0 8px;
`;

const ContentWrapper = styled.div`
  @media (max-width: 650px) {
    margin-bottom: 20px;

    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const H3 = styled(_H3)`
  @media (max-width: 552px) {
    text-align: center;
  }
`;

export default function Vacancy({ slug, name, department }) {
  return (
    <Wrapper>
      <ContentWrapper>
        <H3>
          <Link to={`/vacancy/?id=${slug}`}>{name}</Link>
        </H3>
        <Tags>
          <Tag>{department}</Tag>
        </Tags>
      </ContentWrapper>
      <Link to={`/vacancy/?id=${slug}`}>
        <ButtonContainer>
          <Button as="div">
            <span>Подробнее</span>
          </Button>
        </ButtonContainer>
      </Link>
    </Wrapper>
  );
}
